import Home from '../components/homepage/Home';
import {
  SEO,
  getOrganizationSchema,
  getWebSiteSchema,
} from '../components/elements/SEO';

export default function home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [getOrganizationSchema(), getWebSiteSchema()],
  };

  return (
    <div>
      <SEO
        title="Home"
        description="Data Abyss is an intelligence analysis platform offering advanced search capabilities to identify valuable insights using algorithms and visual analytics. Explore technologies, organizations, publications, and more."
        jsonLd={jsonLd}
      />
      <main>
        <div style={{ paddingTop: 0 }}>
          <Home />
        </div>
      </main>
    </div>
  );
}
